import { Action } from "../../../action";
import { DefaultApi } from "../../../api";
import { getCatchError } from "../../../getCatchError";
import { urls } from "../../../urls";

const setGetUserProfile = (id) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await DefaultApi({
                params: id,
                method: 'get',
                url: urls.GET_USER
            });

            if (data.status === 'success') {
                dispatch(Action.SetGetUserAction(data.data));
            }

        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setGetUserProfile as SetGetUserProfile
}